<template>
  <div>
    <Header />

    <div class="orderContent" v-if="!isCheckout">
      <div class="ordercard">
        <h2 class="modify">
          <span>訂單商品</span>
          <router-link to="/index"><i class="fas fa-reply"></i> 繼續選購</router-link>
        </h2>

        <div class="productCard" v-for="(item, index) in CartData" :key="index">
          <div class="left">
            <img :src="APIURL + 'images/items/' + item.product_image" alt="" /><br />
            <div class="content">
              <h2>{{ item.product_names }}</h2>
              <h3>x{{ item.count }}{{ item.product_unit }}</h3>
            </div>
          </div>
          <p class="right">${{ item.product_sellPrice * item.count }}</p>
          <template v-if="item.isPackage && item.products && item.products.length !== 0">
            <div class="add" v-for="prod in item.products" :key="prod.product_id">
              <img :src="APIURL + 'images/items/' + prod.productImg" alt="" /><br />
              <div class="content">
                <h2>{{ prod.names }}</h2>
                <h3>總共 {{ prod.amount * item.count }} {{ prod.unit }}</h3>
              </div>
            </div>
          </template>
        </div>
        <div
          class="expire"
          style="
            padding: 10px;
            background: rgb(239, 239, 239);
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
          v-if="ExpireData && ExpireData.length > 0"
        >
          <h5 style="">已失效商品</h5>
          <h4 class="expireClean" @click="clearExpire">清除全部</h4>
        </div>

        <div
          class="productCard"
          style="background: rgb(239, 239, 239)"
          v-for="item in ExpireData"
          :key="item.product_id"
        >
          <div class="left">
            <img :src="APIURL + 'images/items/' + item.product_image" alt="" />
            <div class="content">
              <h2>{{ item.product_names }}</h2>
            </div>
          </div>
        </div>
        <!-- <div class="productCard">
          <div class="left">
            <img src="@/assets/images/8.jpeg" alt="" /><br />
            <div class="content">
              <h2>中元普渡組合包</h2>
              <h3>x5箱</h3>
            </div>
          </div>
          <p class="right">$2500</p>
          <template>
            <div class="add">
              <img src="@/assets/images/3.jpeg" alt="" /><br />
              <div class="content">
                <h2>可樂果</h2>
                <h3>x5包</h3>
              </div>
            </div>
            <div class="add">
              <img src="@/assets/images/4.jpeg" alt="" /><br />
              <div class="content">
                <h2>樂事</h2>
                <h3>x3包</h3>
              </div>
            </div>
            <div class="add">
              <img src="@/assets/images/2.jpeg" alt="" /><br />
              <div class="content">
                <h2>麥香紅茶(6入)</h2>
                <h3>x5組</h3>
              </div>
            </div>
          </template>
        </div>
        <div class="productCard">
          <div class="left">
            <img src="@/assets/images/6.jpeg" alt="" /><br />
            <div class="content">
              <h2>可口可樂(6入)</h2>
              <h3>x5組</h3>
            </div>
          </div>
          <p class="right">$250</p>
        </div>
        <div class="productCard">
          <div class="left">
            <img src="@/assets/images/2.jpeg" alt="" /><br />
            <div class="content">
              <h2>麥香紅茶(6入)</h2>
              <h3>x5組</h3>
            </div>
          </div>
          <p class="right">$120</p>
        </div> -->
      </div>
      <div class="ordercard">
        <h2>付款及發貨方式</h2>
        <!-- <ul>
          <li> -->

        <!-- 貨到付款 -->
        <div class="selection">
          <h3 :class="{ active: pay == 1 }" @click="pay = 1">
            <span>貨到付款</span
            ><i class="far" :class="[pay == 1 ? 'fa-check-circle' : 'fa-circle']"></i>
          </h3>
          <ul style="margin: 1vh 1vw" v-if="pay == 1" id="error1">
            <li
              style="
                text-align: left;
                color: red;
                list-style: inside;
                margin: 5px 0;
              "
              v-for="item in errorMsg1"
              :key="item"
            >
              {{ item }}
            </li>
          </ul>
          <div class="list" v-show="pay == 1">
            <div class="gp">
              <label for="">&emsp;收貨人：</label>
              <input type="text" v-model="receiveMan" placeholder="收貨人" />
            </div>
            <div class="gp">
              <label for="">手機號碼：</label>
              <input type="tel" v-model="phone" placeholder="輸入電話號碼" />
            </div>
            <div class="gp">
              <label for="">統一編號：</label>
              <label for="notneed" style="margin-right: 5px"
                >否<input type="radio" v-model="needTaxNum" :value="false" checked id="notneed" />
              </label>
              <label for="need"
                >是<input type="radio" v-model="needTaxNum" :value="true" id="need"
              /></label>

              <input
                type="text"
                v-if="needTaxNum == true"
                v-model="taxNum"
                placeholder="輸入統一編號"
              />
            </div>
            <!-- <div class="gp">
              <label for="">預先轉帳：</label>
              <label for="notneed" style="margin-right: 5px"
                >否<input type="radio" v-model="needTaxNum" :value="false" checked id="notneed" />
              </label>
              <label for="need"
                >是<input type="radio" v-model="needTaxNum" :value="true" id="need"
              /></label>

              <input
                type="text"
                v-if="needTaxNum == true"
                v-model="taxNum"
                placeholder="輸入帳號後四碼"
              />
            </div> -->
            <div class="gp">
              <label for="">運送方式：</label>
              <div v-for="item in Ship" :key="item.id">
                <input
                  type="radio"
                  name="shipss"
                  v-model="shipid"
                  :id="'shipss' + item.id"
                  :value="item.id"
                  v-if="item.type == 1"
                  :checked="shipid == item.id"
                />
                <label :for="'shipss' + item.id" v-if="item.type == 1">{{ item.name }}</label>
              </div>
            </div>
            <div class="gp">
              <label for="">收貨地址：高雄市路竹區</label>
              <!-- <select v-model="selectCity">
                <option :value="item" v-for="item in city" :key="item">
                  {{ item }}
                </option>
              </select>
              <select v-model="selectZip">
                <option
                  :value="item"
                  v-for="item in Object.keys(zip)"
                  :key="item"
                >
                  {{ item }}
                </option>
              </select> -->
              <input type="text" v-model="address" placeholder="輸入地址" />
              <br />
            </div>
            <!-- <div class="gp">
                <label for="">收貨日期：</label
                ><input type="date" v-model="date" />
              </div> -->
            <div class="gp">
              <label for="">收貨時間：</label>
              <div>
                <input
                  type="radio"
                  id="morning"
                  v-model="selectTime1"
                  name="morning"
                  value="9:00~12:00"
                />
                <label for="morning">9:00~12:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="noon"
                  v-model="selectTime1"
                  name="noon"
                  value="12:00~15:00"
                />
                <label for="noon">12:00~15:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="night"
                  v-model="selectTime1"
                  name="night"
                  value="15:00~19:00"
                />
                <label for="night">15:00~19:00</label>
              </div>
              <!-- <input v-model="selectTime1" type="datetime-local" /> -->
            </div>
            <div class="gp" style="flex-wrap: wrap">
              <label for="">備註：</label><br />
              <textarea
                name=""
                id=""
                style="
                  width: 100%;
                  height: 200px;
                  border: 1px solid #b8b8b8;
                  border-radius: 3px;
                  font-size: 1.1rem;
                  padding: 10px;
                  letter-spacing: 1.5px;
                  line-height: 1.8;
                  box-sizing: border-box;
                "
                v-model="comment"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- ATM轉帳 -->
        <div class="selection">
          <h3 :class="{ active: pay == 3 }" @click="pay = 3">
            <span>轉帳</span
            ><i class="far" :class="[pay == 3 ? 'fa-check-circle' : 'fa-circle']"></i>
          </h3>
          <ul style="margin: 1vh 1vw" v-if="pay == 3" id="error3">
            <li
              style="
                text-align: left;
                color: red;
                list-style: inside;
                margin: 5px 0;
              "
              v-for="item in errorC"
              :key="item"
            >
              {{ item }}
            </li>
            <!-- <li
              style="
                text-align: left;
                color: red;
                list-style: inside;
                margin: 5px 0;
              "
              v-for="item in errorMsg1"
              :key="item"
            >
              {{ item }}
            </li> -->
          </ul>
          <div class="list" v-show="pay == 3">
            <div class="gp">
              <label for="">&emsp;收貨人：</label>
              <input type="text" v-model="receiveMan" placeholder="收貨人" />
            </div>
            <div class="gp">
              <label for="">手機號碼：</label>
              <input type="tel" v-model="phone" placeholder="輸入電話號碼" />
            </div>
            <div class="gp">
              <label for="">統一編號：</label>
              <label for="notneed" style="margin-right: 5px"
                >否<input type="radio" v-model="needTaxNum" :value="false" checked id="notneed" />
              </label>
              <label for="need"
                >是<input type="radio" v-model="needTaxNum" :value="true" id="need"
              /></label>

              <input
                type="text"
                v-if="needTaxNum == true"
                v-model="taxNum"
                placeholder="輸入統一編號"
              />
            </div>
            <div class="gp">
              <label for="">銀行轉帳：</label>
              <input type="text" v-model="AccountNumber" placeholder="輸入匯款帳號後四碼" />
              <span>(大力生鮮超市：{{ storeInfo.account }})</span>
            </div>
            <div class="gp">
              <label for="">運送方式：</label>
              <div v-for="item in Ship" :key="item.id">
                <input
                  type="radio"
                  name="ship"
                  v-model="shipid"
                  :id="'ship' + item.id"
                  :value="item.id"
                  v-if="item.type == 1"
                  :checked="shipid == item.id"
                />
                <label :for="'ship' + item.id" v-if="item.type == 1">{{ item.name }} </label>
              </div>
            </div>
            <div class="gp">
              <label for="">收貨地址：高雄市路竹區</label>

              <input type="text" v-model="address" placeholder="輸入地址" />
              <br />
            </div>
            <div class="gp">
              <label for="">收貨時間：</label>
              <div>
                <input
                  type="radio"
                  id="morning3"
                  v-model="selectTime3"
                  name="morning3"
                  value="9:00~12:00"
                />
                <label for="morning3">9:00~12:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="noon3"
                  v-model="selectTime3"
                  name="noon3"
                  value="12:00~15:00"
                />
                <label for="noon3">12:00~15:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="night3"
                  v-model="selectTime3"
                  name="night3"
                  value="15:00~19:00"
                />
                <label for="night3">15:00~19:00</label>
              </div>
            </div>
            <div class="gp" style="flex-wrap: wrap">
              <label for="">備註：</label><br />
              <textarea
                name=""
                id=""
                style="
                  width: 100%;
                  height: 200px;
                  border: 1px solid #b8b8b8;
                  border-radius: 3px;
                  font-size: 1.1rem;
                  padding: 10px;
                  letter-spacing: 1.5px;
                  line-height: 1.8;
                  box-sizing: border-box;
                "
                v-model="comment"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- 信用卡 -->
        <div class="selection">
          <h3 :class="{ active: pay == 4 }" @click="pay = 4">
            <span>信用卡付款</span
            ><i class="far" :class="[pay == 4 ? 'fa-check-circle' : 'fa-circle']"></i>
          </h3>
          <ul style="margin: 1vh 1vw" v-if="pay == 4" id="error4">
            <li
              style="
                text-align: left;
                color: red;
                list-style: inside;
                margin: 5px 0;
              "
              v-for="item in errorD"
              :key="item"
            >
              {{ item }}
            </li>
            <!-- <li
              style="
                text-align: left;
                color: red;
                list-style: inside;
                margin: 5px 0;
              "
              v-for="item in errorMsg1"
              :key="item"
            >
              {{ item }}
            </li> -->
          </ul>
          <div class="list" v-show="pay == 4">
            <div class="gp">
              <label for="">姓名：</label>
              <input type="text" v-model="receiveMan" placeholder="姓名" />
            </div>
            <div class="gp">
              <label for="">手機號碼：</label>
              <input type="tel" v-model="phone" placeholder="輸入電話號碼" />
            </div>
            <div class="gp">
              <label for="">卡號：</label>
              <input type="tel" v-model="creditcard" placeholder="卡號" />
            </div>
            <div class="gp">
              <label for="">有效年月：</label>
              <input
                type="number"
                style="width:50px"
                max="12"
                v-model="valid_month"
                placeholder="MM"
              />
              <span style="margin:0 5px;">/</span>
              <input
                type="number"
                style="width:50px"
                max="31"
                v-model="valid_year"
                placeholder="YY"
              />
            </div>
            <div class="gp">
              <label for="">統一編號：</label>
              <label for="notneed" style="margin-right: 5px"
                >否<input type="radio" v-model="needTaxNum" :value="false" checked id="notneed" />
              </label>
              <label for="need"
                >是<input type="radio" v-model="needTaxNum" :value="true" id="need"
              /></label>

              <input
                type="text"
                v-if="needTaxNum == true"
                v-model="taxNum"
                placeholder="輸入統一編號"
              />
            </div>

            <div class="gp">
              <label for="">運送方式：</label>
              <div v-for="item in Ship" :key="item.id">
                <input
                  type="radio"
                  name="ships"
                  v-model="shipid"
                  :id="'ships' + item.id"
                  :value="item.id"
                  v-if="item.type == 1"
                  :checked="shipid == item.id"
                />
                <label :for="'ships' + item.id" v-if="item.type == 1">{{ item.name }} </label>
              </div>
            </div>
            <div class="gp">
              <label for="">收貨地址：高雄市路竹區</label>

              <input type="text" v-model="address" placeholder="輸入地址" />
              <br />
            </div>
            <div class="gp">
              <label for="">收貨時間：</label>
              <div>
                <input
                  type="radio"
                  id="morning4"
                  v-model="selectTime4"
                  name="morning4"
                  value="9:00~12:00"
                />
                <label for="morning3">9:00~12:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="noon4"
                  v-model="selectTime4"
                  name="noon4"
                  value="12:00~15:00"
                />
                <label for="noon3">12:00~15:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="night4"
                  v-model="selectTime4"
                  name="night4"
                  value="15:00~19:00"
                />
                <label for="night3">15:00~19:00</label>
              </div>
            </div>
            <div class="gp" style="flex-wrap: wrap">
              <label for="">備註：</label><br />
              <textarea
                name=""
                id=""
                style="
                  width: 100%;
                  height: 200px;
                  border: 1px solid #b8b8b8;
                  border-radius: 3px;
                  font-size: 1.1rem;
                  padding: 10px;
                  letter-spacing: 1.5px;
                  line-height: 1.8;
                  box-sizing: border-box;
                "
                v-model="comment"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- 自取 -->
        <div class="selection">
          <h3 :class="{ active: pay == 2 }" @click="pay = 2">
            <span>現場取貨付款</span
            ><i class="far" :class="[pay == 2 ? 'fa-check-circle' : 'fa-circle']"></i>
          </h3>
          <ul style="margin: 1vh 1vw" v-if="pay == 2" id="error2">
            <li
              style="
                text-align: left;
                color: red;
                list-style: inside;
                margin: 5px 0;
              "
              v-for="item in errorB"
              :key="item"
            >
              {{ item }}
            </li>
          </ul>
          <div class="list" v-show="pay == 2">
            <div class="gp">
              <label for="">&emsp;收貨人：</label>
              <input type="text" v-model="receiveMan" placeholder="收貨人" />
            </div>
            <div class="gp">
              <label for="">手機號碼：</label>
              <input type="tel" v-model="phone" placeholder="輸入手機號碼" />
            </div>
            <div class="gp">
              <label for="">統一編號：</label>
              <label for="notneed" style="margin-right: 5px"
                >否<input type="radio" v-model="needTaxNum" :value="false" checked id="notneed" />
              </label>
              <label for="need"
                >是<input type="radio" v-model="needTaxNum" :value="true" id="need"
              /></label>

              <input
                type="text"
                v-if="needTaxNum == true"
                v-model="taxNum"
                placeholder="輸入統一編號"
              />
            </div>
            <div class="gp">
              <label for="">運送方式：</label>
              <div v-for="item in Ship" :key="item.id">
                <input
                  type="radio"
                  name="ship"
                  v-model="shipid"
                  :id="'ship' + item.id"
                  :value="item.id"
                  v-if="item.type == 0"
                  :checked="shipid == '1'"
                />
                <label :for="'ship' + item.id" v-if="item.type == 0">{{ item.name }}</label>
              </div>
              <span style="color: #898989">({{ storeInfo.names }})</span>
            </div>

            <!-- <div class="gp">
                <label for="">取貨店別：</label
                ><input type="text" v-model="selectShop" />
              </div> -->
            <div class="gp">
              <label for="">取貨日期：</label><input type="date" v-model="date" ref="dateinput" />
            </div>
            <div class="gp">
              <label for="">取貨時間：</label>
              <div>
                <input
                  type="radio"
                  id="morning2"
                  v-model="selectTime2"
                  name="morning2"
                  value="9:00~12:00"
                />
                <label for="morning2">9:00~12:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="noon2"
                  v-model="selectTime2"
                  name="noon2"
                  value="12:00~15:00"
                />
                <label for="noon2">12:00~15:00</label>
              </div>

              <div>
                <input
                  type="radio"
                  id="night2"
                  v-model="selectTime2"
                  name="night2"
                  value="15:00~19:00"
                />
                <label for="night2">15:00~19:00</label>
              </div>
              <!-- <input v-model="selectTime2" type="datetime-local" /><br /> -->
            </div>

            <div class="gp" style="flex-wrap: wrap">
              <label for="">備註：</label><br />
              <textarea
                name=""
                id=""
                style="
                  width: 100%;
                  height: 200px;
                  border: 1px solid #b8b8b8;
                  border-radius: 3px;
                  font-size: 1.1rem;
                  padding: 10px;
                  letter-spacing: 1.5px;
                  line-height: 1.8;
                  box-sizing: border-box;
                "
                v-model="comment"
              ></textarea>
            </div>
          </div>
        </div>
        <!-- </li>
        </ul> -->
      </div>
      <div class="ordercard">
        <h2>金額確認</h2>
        <div class="pricies">
          <p>商品總金額：$ {{ CalProductTotal }} 元</p>
          <p>
            運費總金額：
            <span v-if="CalShip && CalProductTotal < CalShip.threshold"
              >${{ parseInt(CalShip.price, 10) }} 元</span
            >
            <span v-if="CalShip && parseInt(CalShip.threshold, 10) === 0">$0</span>
            <span
              v-if="
                CalShip &&
                  CalProductTotal >= CalShip.threshold &&
                  parseInt(CalShip.threshold, 10) > 0
              "
              ><strong style="text-decoration: line-through;font-weight:400"
                >${{ parseInt(CalShip.price, 10) }}</strong
              >(達免運條件)</span
            >
            <span v-if="!CalShip">等待選擇收貨方式</span>
          </p>
          <p class="total">
            總價：$
            <span
              v-if="
                CalShip &&
                  CalProductTotal < CalShip.threshold &&
                  parseInt(CalShip.threshold, 10) > 0
              "
              >{{ CalProductTotal + parseInt(CalShip.price, 10) }} 元</span
            >
            <span v-if="CalShip && parseInt(CalShip.threshold, 10) === 0">
              {{ CalProductTotal }} 元
            </span>
            <span
              v-if="
                CalShip &&
                  CalProductTotal >= CalShip.threshold &&
                  parseInt(CalShip.threshold, 10) > 0
              "
              >{{ CalProductTotal }} 元</span
            >
            <span v-if="!CalShip">等待選擇收貨方式</span>
          </p>
        </div>
        <div class="submitBtn">
          <button
            type="button"
            @click="submitOrder"
            :disabled="!submitSwitch"
            :class="{ disable: !submitSwitch }"
          >
            下訂單
          </button>
          <!-- <button >下訂單</button> -->
        </div>
      </div>
      <!-- <ul>
        <li>
          <img src="@/assets/images/9.jpeg" alt="" />
          <div class="info">
            <h2>麥香紅茶</h2>
            <h3>小計: NT 5000 元</h3>
            價錢
          </div>

        </li>
      </ul> -->
    </div>
    <div class="checkoutContent" v-if="isCheckout">
      <h1>下單成功</h1>
      <div class="iconTitle">
        <i class="fas fa-shopping-cart"></i>
        <i class="fas fa-check"></i>
      </div>
      <!-- <h3>訂單金額(NT)</h3>
      <h4>$<span>2000</span></h4> -->
      <!-- <h5></h5> -->
      <div style="display: flex; justify-content: center">
        <router-link to="/index" tag="button">繼續選購</router-link>
        <router-link to="/status" tag="button">訂單狀態</router-link>
      </div>

      <p style="text-align: center; letter-spacing: 1.5px; color: #a0a0a0">
        {{ gohometime / 1000 }} 秒後跳轉至首頁
      </p>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue';
import tw from '@/assets/tw.json';
import $ from 'jquery';
// import axios from 'axios';
import { isGuiNumberValid } from 'taiwan-id-validator';

export default {
  components: {
    Header,
  },
  computed: {
    nowTime() {
      return new Date();
    },
    ExpireData() {
      return this.$store.state.expireProduct;
    },
    CalProductTotal() {
      let total = 0;
      this.CartData.forEach((item) => {
        total += item.product_sellPrice * item.count;
      });
      return total;
    },
    CartData() {
      return this.$store.state.CartData;
    },
    CalShip() {
      // 運費判斷
      // console.log(
      //   typeof this.shipid,
      //   typeof this.Ship[0].id,
      //   this.Ship.find((item) => item.id === this.shipid),
      // );
      return this.Ship.find((item) => item.id === this.shipid);
    },
    Ship() {
      // 運送方式
      return this.$store.state.ship;
    },
  },
  data() {
    return {
      tw: [],
      city: [],
      zip: [],
      pay: 0, // 1.貨到付款 2.現場取貨 3.轉帳 4.刷卡 5.行動支付
      receiveMan: '',
      selectTime1: '9:00~12:00',
      selectTime2: '9:00~12:00',
      selectTime3: '9:00~12:00',
      selectTime4: '9:00~12:00',
      selectCity: '',
      selectZip: '',
      // selectShop: '',
      valid_month: '', // 信用卡有效月
      valid_year: '', // 信用卡有效年
      creditcard: '', // 信用卡卡號
      errorType: '',
      errorMsg1: [], // 貨到付款錯誤
      errorB: [], // 自取錯誤
      errorC: [], // 轉帳錯誤
      errorD: [], // 信用卡錯誤
      phone: '',
      address: '',
      date: '',
      shipid: '',
      comment: '',
      needTaxNum: false,
      taxNum: '', // 統編
      taxNum_hint: '',
      submitSwitch: true,
      APIURL: process.env.VUE_APP_APIURL,
      // CartData: [],

      AccountNumber: '', // 銀行帳號
      user_name: '',
      user_avator: '',
      user_id: '',

      isCheckout: false,
      gohometime: 5000,

      storeInfo: {},
    };
  },
  created() {
    const vm = this;
    this.LineLoginValidate();
    // if (this.CartData && this.CartData.length === 0) {
    //   alert('沒有採購商品!');
    //   this.$router.push('/');
    // }

    this.$store.dispatch('GET_SHIP_PRICE');
    tw.forEach((item) => {
      vm.city.push(Object.keys(item)[0]);
    });
  },
  mounted() {
    this.$nextTick(() => {
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1; // January is 0 so need to add 1 to make it 1!
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }
      if (mm < 10) {
        mm = `0${mm}`;
      }
      today = `${yyyy}-${mm}-${dd}`;
      const input = this.$refs.dateinput;
      input.setAttribute('min', today);
    });
  },
  methods: {
    validationDate() {
      const vm = this;
      if (vm.date.trim() === '') {
        const indexb = vm.errorB.indexOf('取貨日期不得為空');
        if (indexb === -1) {
          vm.errorB.push('取貨日期不得為空');
        }
      } else {
        const indexB = vm.errorB.indexOf('取貨日期不得為空');
        if (indexB !== -1) {
          vm.errorB.splice(indexB, 1);
        }
      }
    },
    validateTaxNum() {
      const vm = this;
      console.log('統編準備驗證');
      if (vm.needTaxNum) {
        if (vm.taxNum.trim().length !== 8) {
          // alert('未滿8馬');
          const index = vm.errorMsg1.indexOf('統編錯誤');
          const index2 = vm.errorB.indexOf('統編錯誤');
          const index3 = vm.errorC.indexOf('統編錯誤');
          const index4 = vm.errorD.indexOf('統編錯誤');
          if (index === -1) {
            vm.errorMsg1.push('統編錯誤');
          }
          if (index2 === -1) {
            vm.errorB.push('統編錯誤');
          }
          if (index3 === -1) {
            vm.errorC.push('統編錯誤');
          }
          if (index4 === -1) {
            vm.errorD.push('統編錯誤');
          }
        } else {
          console.log('統編驗證', isGuiNumberValid(vm.taxNum));
          if (!isGuiNumberValid(vm.taxNum)) {
            // alert('統編錯誤');
            const index = vm.errorMsg1.indexOf('統編錯誤');
            const index2 = vm.errorB.indexOf('統編錯誤');
            const index3 = vm.errorC.indexOf('統編錯誤');
            const index4 = vm.errorD.indexOf('統編錯誤');
            if (index === -1) {
              vm.errorMsg1.push('統編錯誤');
            }
            if (index2 === -1) {
              vm.errorB.push('統編錯誤');
            }
            if (index3 === -1) {
              vm.errorC.push('統編錯誤');
            }
            if (index4 === -1) {
              vm.errorD.push('統編錯誤');
            }
          } else {
            // alert('統編正確');
            const index = vm.errorMsg1.indexOf('統編錯誤');
            const index2 = vm.errorB.indexOf('統編錯誤');
            const index3 = vm.errorC.indexOf('統編錯誤');
            const index4 = vm.errorD.indexOf('統編錯誤');
            if (index !== -1) {
              vm.errorMsg1.splice(index, 1);
            }
            if (index2 !== -1) {
              vm.errorB.splice(index, 1);
            }
            if (index3 !== -1) {
              vm.errorC.splice(index3, 1);
            }
            if (index4 !== -1) {
              vm.errorD.splice(index4, 1);
            }
          }
        }
      } else {
        const index = vm.errorMsg1.indexOf('統編錯誤');
        const index2 = vm.errorB.indexOf('統編錯誤');
        const index3 = vm.errorC.indexOf('統編錯誤');
        const index4 = vm.errorD.indexOf('統編錯誤');
        if (index !== -1) {
          vm.errorMsg1.splice(index, 1);
        }
        if (index2 !== -1) {
          vm.errorB.splice(index, 1);
        }
        if (index3 !== -1) {
          vm.errorC.splice(index3, 1);
        }
        if (index4 !== -1) {
          vm.errorD.splice(index4, 1);
        }
      }
    },
    validatePhone() {
      const vm = this;
      const PhoneReg = /^(09)[0-9]{8}$/;
      if (vm.phone.trim() === '' || !PhoneReg.test(vm.phone.trim())) {
        // console.log('格式錯誤');
        const index = vm.errorMsg1.indexOf('手機格式錯誤');
        const index2 = vm.errorB.indexOf('手機格式錯誤');
        const index3 = vm.errorC.indexOf('手機格式錯誤');
        const index4 = vm.errorD.indexOf('手機格式錯誤');
        if (index === -1 && index2 === -1 && index3 === -1 && index4 === -1) {
          vm.errorMsg1.push('手機格式錯誤');
          vm.errorB.push('手機格式錯誤');
          vm.errorC.push('手機格式錯誤');
          vm.errorD.push('手機格式錯誤');
        }
      } else {
        const index = vm.errorMsg1.indexOf('手機格式錯誤');
        const index2 = vm.errorB.indexOf('手機格式錯誤');
        const index3 = vm.errorC.indexOf('手機格式錯誤');
        const index4 = vm.errorD.indexOf('手機格式錯誤');
        if (index !== -1 && index2 !== -1 && index3 !== -1 && index4 !== -1) {
          vm.errorMsg1.splice(index, 1);
          vm.errorB.splice(index, 1);
          vm.errorC.splice(index3, 1);
          vm.errorD.splice(index4, 1);
        }
      }
    },
    validateAddress() {
      const vm = this;
      // if (vm.selectCity.trim() === '' || vm.selectZip.trim() === ''
      // || vm.address.trim() === '') {
      //   const index = vm.errorMsg1.indexOf('收貨地址格式錯誤');
      //   if (index === -1) {
      //     vm.errorMsg1.push('收貨地址格式錯誤');
      //   }
      // } else {
      //   const index = vm.errorMsg1.indexOf('收貨地址格式錯誤');
      //   if (index !== -1) {
      //     vm.errorMsg1.splice(index, 1);
      //   }
      // }
      if (vm.address.trim() === '') {
        const index = vm.errorMsg1.indexOf('收貨地址格式錯誤');
        const index3 = vm.errorC.indexOf('收貨地址格式錯誤');
        const index4 = vm.errorD.indexOf('收貨地址格式錯誤');
        if (index === -1) {
          vm.errorMsg1.push('收貨地址格式錯誤');
        }
        if (index3 === -1) {
          vm.errorC.push('收貨地址格式錯誤');
        }
        if (index4 === -1) {
          vm.errorD.push('收貨地址格式錯誤');
        }
      } else {
        const index = vm.errorMsg1.indexOf('收貨地址格式錯誤');
        const index3 = vm.errorC.indexOf('收貨地址格式錯誤');
        const index4 = vm.errorD.indexOf('收貨地址格式錯誤');
        if (index !== -1) {
          vm.errorMsg1.splice(index, 1);
        }
        if (index3 !== -1) {
          vm.errorC.splice(index3, 1);
        }
        if (index4 !== -1) {
          vm.errorD.splice(index4, 1);
        }
      }
    },
    validateShop() {
      const vm = this;
      if (vm.selectShop.trim() === '') {
        const index = vm.errorB.indexOf('取貨店家不得為空');
        if (index === -1) {
          vm.errorB.push('取貨店家不得為空');
        }
      } else {
        const index = vm.errorB.indexOf('取貨店家不得為空');
        if (index !== -1) {
          vm.errorB.splice(index, 1);
        }
      }
    },
    validationReceiveMan() {
      const vm = this;
      // if (pay === 1) {
      if (vm.receiveMan.trim() === '') {
        const index = vm.errorMsg1.indexOf('收貨人不得為空');
        const indexB = vm.errorB.indexOf('取貨人不得為空');
        const index3 = vm.errorC.indexOf('收貨人不得為空');
        const index4 = vm.errorD.indexOf('姓名不得為空');
        if (index === -1) {
          vm.errorMsg1.push('收貨人不得為空');
        }
        if (indexB === -1) {
          vm.errorB.push('取貨人不得為空');
        }
        if (index3 === -1) {
          vm.errorC.push('收貨人不得為空');
        }
        if (index4 === -1) {
          vm.errorD.push('姓名不得為空');
        }
      } else {
        const index = vm.errorMsg1.indexOf('收貨人不得為空');
        const indexB = vm.errorB.indexOf('取貨人不得為空');
        const index3 = vm.errorC.indexOf('收貨人不得為空');
        const index4 = vm.errorD.indexOf('姓名不得為空');
        if (index !== -1) {
          vm.errorMsg1.splice(index, 1);
        }
        if (indexB !== -1) {
          vm.errorB.splice(indexB, 1);
        }
        if (index3 !== -1) {
          vm.errorC.splice(index3, 1);
        }
        if (index4 !== -1) {
          vm.errorD.splice(index4, 1);
        }
      }
    },
    // validationShip(pay) {
    //   const vm = this;
    //   if (pay === 1 && vm.shipid === '1') {
    //     const index = vm.errorMsg1.indexOf('請選擇運送方式');
    //     if (index === -1) {
    //       vm.errorMsg1.push('請選擇運送方式');
    //     }
    //   } else {
    //     const index = vm.errorMsg1.indexOf('請選擇運送方式');
    //     if (index !== -1) {
    //       vm.errorMsg1.splice(index, 1);
    //     }
    //   }
    // },
    validateAccount() {
      const vm = this;
      if (vm.pay === 3 && vm.AccountNumber.trim().length !== 4) {
        const index = vm.errorC.indexOf('帳戶後四碼錯誤');
        if (index === -1) {
          vm.errorC.push('帳戶後四碼錯誤');
        }
      } else {
        const index = vm.errorC.indexOf('帳戶後四碼錯誤');
        if (index !== -1) {
          vm.errorC.splice(index, 1);
        }
      }
    },
    validateCreditCard() {
      const vm = this;
      if (vm.pay === 4 && vm.creditcard.trim() === '') {
        const index = vm.errorD.indexOf('信用卡格式不完整');
        if (index === -1) {
          vm.errorD.push('信用卡格式不完整');
        }
      } else {
        const index = vm.errorD.indexOf('信用卡格式不完整');
        if (index !== -1) {
          vm.errorD.splice(index, 1);
        }
      }
    },
    validateCreditDate() {
      const vm = this;
      if (vm.pay === 4 && (vm.valid_month.trim() === '' || vm.valid_year.trim() === '')) {
        const index = vm.errorD.indexOf('信用卡日期格式錯誤');
        if (index === -1) {
          vm.errorD.push('信用卡日期格式錯誤');
        }
      } else {
        const index = vm.errorD.indexOf('信用卡日期格式錯誤');
        if (index !== -1) {
          vm.errorD.splice(index, 1);
        }
      }
      if (vm.pay === 4 && vm.valid_month > 12) {
        const index = vm.errorD.indexOf('信用卡月份格式錯誤');
        if (index === -1) {
          vm.errorD.push('信用卡月份格式錯誤');
        }
      } else {
        const index = vm.errorD.indexOf('信用卡月份格式錯誤');
        if (index !== -1) {
          vm.errorD.splice(index, 1);
        }
      }
    },
    can_select_zip() {
      // console.log(this.tw[this.selectCity]);
      tw.forEach((item) => {
        if (Object.keys(item)[0] === this.selectCity) {
          this.zip = item[this.selectCity];
          console.log(item);
        }
      });
      // this.zip = tw[this.selectCity];
      this.selectZip = '';
    },

    submitOrder() {
      const vm = this;
      if (!vm.CartData || vm.CartData.length === 0) {
        alert('購物車為空');
        this.$router.push('/');
        return;
      }

      vm.validationReceiveMan();
      vm.validatePhone();
      vm.validateAddress();
      // vm.validateShop();
      vm.validationDate();
      // vm.validationShip(vm.pay);
      // if (vm.needTaxNum) {
      vm.validateTaxNum();
      vm.validateAccount();
      vm.validateCreditCard();
      vm.validateCreditDate();
      // }
      if (vm.pay === 1 && vm.errorMsg1.length !== 0) {
        alert('貨到付款資料填寫有誤');
      } else if (vm.pay === 2 && vm.errorB.length !== 0) {
        alert('現場取貨付款資料填寫有誤');
      } else if (vm.pay === 3 && vm.errorC.length !== 0) {
        alert('ATM付款資料填寫有誤');
      } else if (vm.pay === 4 && vm.errorD.length !== 0) {
        alert('信用卡付款資料填寫有誤');
      } else if (vm.ExpireData && vm.ExpireData.length > 0) {
        // 判斷商品是否上架
        alert('訂單中有產品已下架，清除後繼續');
      } else {
        vm.carts = [];
        vm.CartData.forEach((item) => {
          vm.carts.push({
            count: item.count,
            id: item.product_id,
            isPackage: item.isPackage,
            name: item.product_names,
          });
        });
        switch (vm.pay) {
          case 0:
            alert('請選擇收貨方式');
            break;
          case 1:
            // 貨到付款
            if (vm.errorMsg1.length === 0) {
              vm.$store.commit('setLoading', true);
              $.ajax({
                url: `${process.env.VUE_APP_APIURL}front/cart/add_cart`,
                type: 'POST',
                data: {
                  pay: vm.pay, // '1 貨到付款',
                  phone: vm.phone,
                  address: `高雄市路竹區${vm.address}`,
                  time: vm.selectTime1,
                  cart: vm.carts,
                  receive: vm.receiveMan,
                  clientId: vm.user_id,
                  // date: vm.date,
                  ship: vm.shipid,
                  comment: vm.comment,
                  taxNum: vm.needTaxNum ? vm.taxNum : 0,
                },
                success(res) {
                  vm.$store.commit('setLoading', false);
                  console.log(res);
                  if (res === '') {
                    vm.isCheckout = true;
                    vm.$store.commit('localStorageOverWrite', []);
                    localStorage.removeItem('cartdata');
                    console.log('成功');
                  } else {
                    alert(`${res}庫存不足`);
                  }
                },
              });
            }

            break;
          case 2:
            // 現場取貨付款
            if (vm.errorB.length === 0) {
              vm.$store.commit('setLoading', true);
              $.ajax({
                url: `${process.env.VUE_APP_APIURL}front/cart/add_cart`,
                type: 'POST',
                data: {
                  pay: vm.pay, //  '2 現場取貨付款',
                  phone: vm.phone,
                  // address: vm.selectShop,
                  time: vm.selectTime2,
                  cart: vm.carts,
                  receive: vm.receiveMan,
                  date: vm.date,
                  ship: vm.shipid,
                  comment: vm.comment,
                  clientId: vm.user_id,
                  taxNum: vm.needTaxNum ? vm.taxNum : 0,
                },
                success(res) {
                  vm.$store.commit('setLoading', false);
                  console.log(res);
                  if (res === '') {
                    console.log('成功');
                    vm.isCheckout = true;
                    vm.$store.commit('localStorageOverWrite', []);
                    localStorage.removeItem('cartdata');
                  } else {
                    alert(`${res}庫存不足`);
                  }
                },
              });
            }
            break;
          case 3:
            // ATM轉帳
            if (vm.errorC.length === 0) {
              // alert('沒有問');
              vm.$store.commit('setLoading', true);
              $.ajax({
                url: `${process.env.VUE_APP_APIURL}front/cart/add_cart`,
                type: 'POST',
                data: {
                  pay: vm.pay, //  '3 轉帳',
                  phone: vm.phone,
                  address: `高雄市路竹區${vm.address}`,
                  time: vm.selectTime3,
                  cart: vm.carts,
                  receive: vm.receiveMan,
                  date: vm.date,
                  ship: vm.shipid,
                  comment: vm.comment,
                  clientId: vm.user_id,
                  taxNum: vm.needTaxNum ? vm.taxNum : 0,
                  account: vm.AccountNumber,
                },
                success(res) {
                  vm.$store.commit('setLoading', false);
                  console.log(res);
                  if (res === '') {
                    console.log('成功');
                    vm.isCheckout = true;
                    vm.$store.commit('localStorageOverWrite', []);
                    localStorage.removeItem('cartdata');
                  } else {
                    alert(`${res}庫存不足`);
                  }
                },
              });
            }
            break;
          case 4:
            if (vm.errorD.length === 0) {
              alert('送出信用卡訂單');
            }
            break;
          default:
            break;
        }
      }

      // -----------------------
      // const localdata = JSON.parse(localStorage.getItem('cartdata'));
      // const enableProduct = [];
      // const disableProduct = [];
      // vm.$store.commit('setLoading', true);
      // $.ajax({
      //   url: `${process.env.VUE_APP_APIURL}front/cart/expire_product`,
      //   type: 'POST',
      //   data: {
      //     cart: localdata,
      //   },
      //   success(checkproduct) {
      //     console.log(checkproduct);
      //     const data = JSON.parse(checkproduct);
      //     console.log(data);
      //     const newLocalStorage = [];
      //     const packages = data.package;
      //     const { product } = data;
      //     packages.forEach((item) => {
      //       newLocalStorage.push(item);
      //       if (item.expire === 1) {
      //         enableProduct.push(item);
      //       } else if (item.expire === 0) {
      //         disableProduct.push(item);
      //       }
      //     });
      //     product.forEach((item) => {
      //       newLocalStorage.push(item);
      //       if (item.expire === 1) {
      //         enableProduct.push(item);
      //       } else if (item.expire === 0) {
      //         disableProduct.push(item);
      //       }
      //     });
      //     vm.$store.commit('localStorageOverWrite', enableProduct);
      //     vm.$store.commit('setexpireProduct', disableProduct);

      // if (disableProduct.length > 0) {
      //   vm.$store.commit('setLoading', false);
      //   alert('訂單中有產品已下架，清除後繼續');
      // } else {
      //   vm.carts = [];
      //   vm.CartData.forEach((item) => {
      //     vm.carts.push({
      //       count: item.count,
      //       id: item.product_id,
      //       isPackage: item.isPackage,
      //       name: item.product_names,
      //     });
      //   });
      //   switch (vm.pay) {
      //     case 0:
      //       vm.$store.commit('setLoading', false);
      //       alert('請選擇收貨方式');
      //       break;
      //     case 1:
      //       // 貨到付款
      //       if (vm.errorMsg1.length === 0) {
      //         // vm.$store.commit('setLoading', true);
      //         $.ajax({
      //           url: `${process.env.VUE_APP_APIURL}front/cart/add_cart`,
      //           type: 'POST',
      //           data: {
      //             pay: '貨到付款',
      //             phone: vm.phone,
      //             address: `高雄市路竹區${vm.address}`,
      //             time: vm.selectTime1,
      //             cart: vm.carts,
      //             receive: vm.receiveMan,
      //             clientId: vm.user_id,
      //             // date: vm.date,
      //             ship: vm.shipid,
      //             comment: vm.comment,
      //             taxNum: vm.needTaxNum ? vm.taxNum : 0,
      //           },
      //           success(res) {
      //             vm.$store.commit('setLoading', false);
      //             console.log(res);
      //             if (res === '') {
      //               vm.isCheckout = true;
      //               vm.$store.commit('localStorageOverWrite', []);
      //               localStorage.removeItem('cartdata');
      //               console.log('成功');
      //             } else {
      //               alert(`${res}庫存不足`);
      //             }
      //           },
      //         });
      //       }

      //       break;
      //     case 2:
      //       // 現場取貨付款
      //       if (vm.errorB.length === 0) {
      //         // vm.$store.commit('setLoading', true);
      //         $.ajax({
      //           url: `${process.env.VUE_APP_APIURL}front/cart/add_cart`,
      //           type: 'POST',
      //           data: {
      //             pay: '現場取貨付款',
      //             phone: vm.phone,
      //             // address: vm.selectShop,
      //             time: vm.selectTime2,
      //             cart: vm.carts,
      //             receive: vm.receiveMan,
      //             date: vm.date,
      //             ship: vm.shipid,
      //             comment: vm.comment,
      //             clientId: vm.user_id,
      //             taxNum: vm.needTaxNum ? vm.taxNum : 0,
      //           },
      //           success(res) {
      //             vm.$store.commit('setLoading', false);
      //             console.log(res);
      //             if (res === '') {
      //               console.log('成功');
      //               vm.isCheckout = true;
      //               vm.$store.commit('localStorageOverWrite', []);
      //               localStorage.removeItem('cartdata');
      //             } else {
      //               alert(`${res}庫存不足`);
      //             }
      //           },
      //         });
      //       }
      //       break;
      //     case 3:
      //       // ATM轉帳
      //       if (vm.errorB.length === 0 && vm.errorC.length === 0) {
      //         // vm.$store.commit('setLoading', true);
      //         $.ajax({
      //           url: `${process.env.VUE_APP_APIURL}front/cart/add_cart`,
      //           type: 'POST',
      //           data: {
      //             pay: 'ATM付款',
      //             phone: vm.phone,
      //             // address: vm.selectShop,
      //             time: vm.selectTime3,
      //             cart: vm.carts,
      //             receive: vm.receiveMan,
      //             date: vm.date,
      //             ship: vm.shipid,
      //             comment: vm.comment,
      //             clientId: vm.user_id,
      //             taxNum: vm.needTaxNum ? vm.taxNum : 0,
      //             account: vm.AccountNumber,
      //           },
      //           success(res) {
      //             vm.$store.commit('setLoading', false);
      //             console.log(res);
      //             if (res === '') {
      //               console.log('成功');
      //               vm.isCheckout = true;
      //               vm.$store.commit('localStorageOverWrite', []);
      //               localStorage.removeItem('cartdata');
      //             } else {
      //               alert(`${res}庫存不足`);
      //             }
      //           },
      //         });
      //       }
      //       break;
      //     default:
      //       break;
      //   }
      // }
      //   },
      // });
      // }
      // }
    },
    LineLoginValidate() {
      console.log('驗證line');
      const vm = this;
      if (this.$cookies.get('access_token')) {
        // alert('有登入過');
        // 驗證如果登入過

        $.ajax({
          url: 'https://api.line.me/v2/profile',
          type: 'GET',
          headers: {
            Authorization: `Bearer ${vm.$cookies.get('access_token')}`,
          },
          success(user) {
            console.log(user);
            if (user.displayName && user.pictureUrl && user.userId) {
              vm.user_name = user.displayName;
              vm.receiveMan = user.displayName;
              vm.user_avator = user.pictureUrl;
              // let line_user_id = user.userId;
              // 取得資料後傳至後端
              $.ajax({
                url: `${process.env.VUE_APP_APIURL}front/account/line_login`,
                type: 'POST',
                data: {
                  user_name: user.displayName,
                  user_id: user.userId,
                },
                success(ok) {
                  console.log('ok', ok);
                  // console.log();
                  const oks = JSON.parse(ok);
                  vm.user_id = oks.clientId;
                  console.log('取資料', oks.clientId);
                  $.ajax({
                    url: `${process.env.VUE_APP_APIURL}front/account/login_detail`,
                    type: 'POST',
                    data: {
                      user_id: oks.clientId,
                    },
                    success(res) {
                      console.log('店家資料');
                      const data = JSON.parse(res);
                      console.log('曾經登入的資訊', data);
                      // 1是沒有送過訂單
                      if (data.info.status !== 1) {
                        vm.receiveMan = data.info.clientName;
                        vm.address = data.info.address;
                        vm.phone = data.info.phone;
                        if (data.info.taxNum == null) {
                          vm.needTaxNum = false;
                        } else {
                          vm.needTaxNum = true;
                          vm.taxNum = data.info.taxNum;
                        }
                      }
                      const store = data.admin[0];
                      vm.storeInfo = store;
                    },
                  });
                },
              });
            } else {
              console.log('有登入');
              vm.$cookies.remove('access_token');
              const clientId = process.env.VUE_APP_LINECLIENTID;
              const redirectUri = `${process.env.VUE_APP_URL}order`;
              let link = 'https://access.line.me/oauth2/v2.1/authorize?';
              link += 'response_type=code';
              link += `&client_id=${clientId}`;
              link += `&redirect_uri=${redirectUri}`;
              link += '&state=login';
              link += '&scope=profile%20openid%20email';
              window.location.href = link;
            }
          },
        });
      } else if (this.$route.query.code) {
        // alert('有code');
        // 取得code query
        // console.log(vm.$route.query.code, process.env.VUE_APP_URL);
        $.ajax({
          url: 'https://api.line.me/oauth2/v2.1/token',
          type: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: {
            grant_type: 'authorization_code',
            client_id: process.env.VUE_APP_LINECLIENTID,
            client_secret: process.env.VUE_APP_LINESC,
            code: vm.$route.query.code,
            redirect_uri: `${process.env.VUE_APP_URL}order`,
          },
          success(res) {
            console.log(res);
            if (res.access_token) {
              vm.$cookies.set('access_token', res.access_token, 60 * 60 * 24 * 20);
              $.ajax({
                url: 'https://api.line.me/v2/profile',
                type: 'GET',
                headers: {
                  Authorization: `Bearer ${res.access_token}`,
                },
                success(user) {
                  console.log('user', user);
                  vm.user_name = user.displayName;
                  vm.receiveMan = user.displayName;
                  vm.user_avator = user.pictureUrl;
                  // vm.user_id = user.userId;
                  // 取得資料後傳至後端
                  $.ajax({
                    url: `${process.env.VUE_APP_APIURL}front/account/line_login`,
                    type: 'POST',
                    data: {
                      user_name: user.displayName,
                      user_id: user.userId,
                    },
                    success(ok) {
                      console.log('ok', ok);
                      const oks = JSON.parse(ok);
                      vm.user_id = oks.clientId;
                      console.log('取資料', oks.clientId);
                      $.ajax({
                        url: `${process.env.VUE_APP_APIURL}front/account/login_detail`,
                        type: 'POST',
                        data: {
                          user_id: oks.clientId,
                        },
                        success(respond) {
                          const data = JSON.parse(respond);
                          console.log(data);
                          if (data !== 1) {
                            vm.receiveMan = data.clientName;
                            vm.address = data.address;
                            vm.phone = data.phone;
                            if (data.taxNum == null) {
                              vm.needTaxNum = false;
                            } else {
                              vm.needTaxNum = true;
                              vm.taxNum = data.taxNum;
                            }
                          }
                          // const data = JSON.parse(respond);
                          // console.log(data);
                        },
                      });
                      // vm.$router.push('/order');
                    },
                  });
                },
              });
            }
          },
        });
      } else {
        // alert('沒code');
        const clientId = process.env.VUE_APP_LINECLIENTID;
        const redirectUri = `${process.env.VUE_APP_URL}order`;
        let link = 'https://access.line.me/oauth2/v2.1/authorize?';
        link += 'response_type=code';
        link += `&client_id=${clientId}`;
        link += `&redirect_uri=${redirectUri}`;
        link += '&state=login';
        link += '&scope=profile%20openid%20email';
        window.location.href = link;
      }
      // console.log('this.$route.query.code', this.$route.query.code);
    },
    GoHome() {
      const vm = this;
      setTimeout(() => {
        if (vm.gohometime > 0) {
          vm.gohometime -= 1000;
          vm.GoHome();
        }
      }, 1000);
    },
    clearExpire() {
      const vm = this;
      const oldStorage = JSON.parse(JSON.stringify(JSON.parse(localStorage.getItem('cartdata'))));
      const newStorage = [];
      for (let i = 0; i < oldStorage.length; i += 1) {
        vm.isCommon = false;
        for (let j = 0; j < this.ExpireData.length; j += 1) {
          if (oldStorage[i].product_id === vm.ExpireData[j].product_id) {
            vm.isCommon = true;
          }
        }
        if (!vm.isCommon) {
          newStorage.push(oldStorage[i]);
        }
      }
      localStorage.setItem('cartdata', JSON.stringify(newStorage));
      this.$store.commit('setexpireProduct', []);
    },
  },
  watch: {
    selectCity() {
      this.can_select_zip();
    },
    pay() {
      console.log('pay變了');
      if (this.pay === 1) {
        const data = this.Ship.find((item) => item.type === '1');
        console.log('data', data);
        this.shipid = data.id;
      } else if (this.pay === 2) {
        const data = this.Ship.find((item) => item.type === '0');
        console.log('data', data);
        this.shipid = data.id;
      } else if (this.pay === 3) {
        const data = this.Ship.find((item) => item.type === '1');
        console.log('data', data);
        this.shipid = data.id;
      }
    },
    isCheckout() {
      // const vm = this;
      if (this.isCheckout === true) {
        // setTimeout(vm.GoHome, 1000);
        // vm.
        this.GoHome();
      }
    },
    gohometime() {
      if (this.gohometime === 0) {
        this.$router.push('/');
      }
    },
  },
};
</script>

<style></style>
